import { useScrollY } from '@/hooks/useScrollY'
import Hero from '@/components/landing/Hero'
import SocialProofBar from '@/components/landing/SocialProofBar'
import ToolsSection from '@/components/landing/ToolsSection'
import LeadMagnets from '@/components/landing/LeadMagnets'
import ServicesSection from '@/components/landing/ServicesSection'
import WorkshopCTA from '@/components/landing/WorkshopCTA'
import AboutSection from '@/components/landing/AboutSection'
import Footer from '@/components/landing/Footer'

export default function Landing() {
  const scrollY = useScrollY()

  return (
    <div className="min-h-screen overflow-x-hidden">
      <Hero scrollY={scrollY} />
      <SocialProofBar />
      <ToolsSection />
      <LeadMagnets />
      <ServicesSection />
      <WorkshopCTA />
      <AboutSection />
      <Footer />
    </div>
  )
}
